/* eslint-disable react/prop-types */
import { Button, IconButton, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import MergeTypeIcon from '@material-ui/icons/MergeType'
import React from 'react'

import { useAccess } from 'app/hooks/useAccess'

import { columns, tableOptions } from './config'
import { MergeStudentsDialog } from './MergeStudentsDialog'
import { StyledMUIDataTable } from './styles'

export const DataTable = ({
  title,
  data,
  setData,
  fieldName,
  setFieldValue,
  options = {}
}) => {
  const { isSuperAdmin } = useAccess()
  const [mergeStudents, setMergeStudents] = React.useState(null)
  const clearSelection = React.useRef(null)

  const table = React.useMemo(
    () => (
      <StyledMUIDataTable
        title={title}
        columns={columns}
        data={data}
        options={{
          ...tableOptions,
          customFooter: () => <tfoot />,
          // Replaces mui-datatables' built-in trash icon, so delete is
          // rendered here: Merge for everyone, Delete for super admins only.
          customToolbarSelect: (selectedRows, _, setSelectedRows) => {
            const dataIndexes = selectedRows.data.map(
              ({ dataIndex }) => dataIndex
            )
            const canMerge = dataIndexes.length >= 2

            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip
                  title={
                    canMerge
                      ? 'Merge duplicate profiles'
                      : 'Select at least 2 students to merge'
                  }
                >
                  <span>
                    <Button
                      variant="outlined"
                      startIcon={<MergeTypeIcon />}
                      disabled={!canMerge}
                      onClick={() => {
                        clearSelection.current = () => setSelectedRows([])
                        setMergeStudents(dataIndexes.map((i) => data[i]))
                      }}
                    >
                      Merge
                    </Button>
                  </span>
                </Tooltip>
                {isSuperAdmin && (
                  <Tooltip title="Delete">
                    <IconButton
                      style={{ marginLeft: 8 }}
                      onClick={() => {
                        const remaining = data.filter(
                          (_, i) => !dataIndexes.includes(i)
                        )
                        setSelectedRows([])
                        setData(remaining)
                        setFieldValue(fieldName, remaining)
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            )
          },
          onTableChange: (action, tableState) => {
            if (['rowDelete', 'propsUpdate'].includes(action)) {
              const student = tableState.data.map(
                (student) => data[student.index]
              )
              setFieldValue(fieldName, student)
            }
          },
          ...options
        }}
      />
    ),
    [data, isSuperAdmin]
  )

  return (
    <>
      {table}
      <MergeStudentsDialog
        students={mergeStudents}
        onClose={() => setMergeStudents(null)}
        onMerged={(mergedUuids) => {
          const remaining = data.filter(
            ({ user }) => !mergedUuids.includes(user.uuid)
          )
          clearSelection.current?.()
          setData(remaining)
          setFieldValue(fieldName, remaining)
        }}
      />
    </>
  )
}
